"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 700px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var pdfClass = (0, _core.css)(_templateObject());

var PDF = function PDF(_ref) {
  var url = _ref.url;
  return (0, _core.jsx)("object", {
    css: pdfClass,
    data: url,
    type: "application/pdf"
  }, (0, _core.jsx)("a", {
    href: url
  }, url));
};

PDF.displayName = "PDF";
PDF.propTypes = {
  url: _propTypes["default"].string
};
PDF.defaultProps = {
  url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
};
var _default = PDF;
exports["default"] = _default;